import React from 'react';
import classNames from 'classnames';
import { Text, Card, Stack, Icon, Tag } from '@servicetitan/design-system';
import { SignatureDocument } from '../../stores/signature.store';
import { VisitActionRequestTimeZone } from 'src/api/model/visitActionRequestTimeZone';
import styles from './document-list-item-card.less';

interface DocumentListItemCardProps {
    name?: string;
    signed: boolean;
    signedOn?: string;
    requestedOn: string;
    tenantTimeZone?: VisitActionRequestTimeZone;
    isProject: boolean;
    onClick: (item: SignatureDocument) => void;
}

export const DocumentListItemCard: React.FC<DocumentListItemCardProps> = React.memo(
    (props: DocumentListItemCardProps) => {
        const { signed, signedOn, requestedOn, name, tenantTimeZone, isProject, onClick } = props;

        const dateToDisplay = signed ? signedOn : requestedOn;
        let dayFormatted;
        let timeFormatted;
        if (dateToDisplay) {
            const date = new Date(dateToDisplay);
            dayFormatted = date.toLocaleDateString(undefined, {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
            timeFormatted = date.toLocaleTimeString(undefined, {
                hour: '2-digit',
                minute: '2-digit',
            });
            if (tenantTimeZone && tenantTimeZone.timeZoneAbbreviation) {
                timeFormatted += ` ${tenantTimeZone.timeZoneAbbreviation}`;
            }
        }

        return (
            <Card className={classNames('m-b-1', styles.card)} onClick={onClick}>
                <Stack justifyContent="space-between">
                    <Stack.Item alignSelf="center">
                        {signed ? (
                            <Icon
                                name={isProject ? 'assignment_turned_in' : 'check_circle'}
                                size={28}
                                className="c-green-500"
                            />
                        ) : (
                            <Icon
                                name={isProject ? 'assignment_late' : 'description'}
                                size={28}
                                className="c-blue-400"
                            />
                        )}
                    </Stack.Item>
                    <Stack.Item className="w-100 p-x-2" shrink={1}>
                        <Stack direction="column">
                            <Text el="span" size="2" bold className="t-truncate">
                                {name || ''}
                            </Text>
                            <Text
                                el="span"
                                size="1"
                                className={classNames('t-truncate c-neutral-90', styles.date)}
                            >
                                {isProject && (
                                    <Tag compact className="m-r-1">
                                        For Project
                                    </Tag>
                                )}
                                {signed ? 'Signed' : 'Received'}
                                {dateToDisplay ? ` ${dayFormatted} at ${timeFormatted}` : ''}
                            </Text>
                        </Stack>
                    </Stack.Item>
                    <Stack.Item alignSelf="center">
                        <Icon
                            name="chevron_right"
                            size={28}
                            className={signed ? 'c-neutral-400' : 'c-blue-400'}
                        />
                    </Stack.Item>
                </Stack>
            </Card>
        );
    }
);
